module.exports = __webpack_public_path__ + "img/servicesReservationEmployeeBenefit.598a96c3.svg";